import r from "./highrise1606.mjs";
import m from "./highrise1607.mjs";
import h from "./highrise1608.mjs";
import l from "./highrise1609.mjs";
import c from "./highrise1610.mjs";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++o < a; ) {
    var p = t[o];
    this.set(p[0], p[1]);
  }
}
e.prototype.clear = r;
e.prototype.delete = m;
e.prototype.get = h;
e.prototype.has = l;
e.prototype.set = c;
export {
  e as default
};
